import styled from 'styled-components';
import { Box, Paper, FormControlLabel } from '@mui/material';
import { colors } from 'spw-theme';
import { Row } from 'spw-shared/globalComponents';
import withStyles from '@mui/styles/withStyles';
import { Tooltip } from 'spw-shared/globalComponents/icons';

export const WithoutBuildingMessage = styled(Row)`
  && {
    color: ${colors.darkGray};
    padding-top: 30%;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
`;

export const HeadcountBox = styled(Box)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
`;

export const HeadcountLabelBox = styled(HeadcountBox)`
  && {
    color: ${colors.black};
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;

export const HeadcountFormControlLabel = styled(FormControlLabel)`
  && {
    span {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }

    &.selected {
      span {
        font-weight: 500;
      }
    }
  }
`;

export const TooltipText = styled(Box)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const TooltipTitle = styled.h3`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-top: 0;
  margin-bottom: 8px;
`;

export const TooltipContainer = styled(Paper)`
  box-sizing: border-box;
  padding: 16px;
  width: 332px;
  min-height: 120px;
  overflow: auto;
`;

export const HeadcountSourceTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: 332,
  },
}))(Tooltip);

export const DownloadButtonBox = styled(Box)`
  && {
    margin-left: 16px;
  }
`;
